import React, { Component } from 'react';
import { Icon } from "semantic-ui-react";
import moment from "moment";
import { adpLink } from "../../constants"
import { showFinancialNotesTable, showTedCollectionsTable } from "./functions";
import { formatCurrency } from '../../utils/commonutils';

class GOx extends Component {
    render() {
        const { providerData, startDate, earnings, details, payDetails } = this.props
        const { numberOfWorkedDays, patientVisits, patientVisitsPerDay, contractType, dentistWorkTimeType, prodAdjWo, percentageOfBillable, doctorPayVariables, sortName, financialNoteList, financialNotes } = providerData;
        const annualizedPay = earnings * 12;
        const dailyRatePay = (earnings / numberOfWorkedDays);
        const { payChecks, hygData } = details;

        return (
            <div>
                <div className="row">
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>{sortName}</h5>
                                <ul className="data-list">
                                    <li>
                                        <p>Pay Month</p>
                                        <p>{moment(startDate).add(1, 'months').format('MMMM YYYY')}</p>
                                    </li>
                                    <li>
                                        <p>Work Month</p>
                                        <p>{moment(startDate).format('MMMM YYYY')}</p>
                                    </li>
                                    <li>
                                        <p>Work Days</p>
                                        <p>{numberOfWorkedDays}</p>
                                    </li>
                                    <li>
                                        <p>Work Month Base Pay</p>
                                        <p>{formatCurrency(doctorPayVariables.monthlyBasePay)}</p>
                                    </li>
                                    <li>
                                        <p>Work Month Billable Threshold</p>
                                        <p>{"**"}</p>
                                    </li>
                                    <li>
                                        <p>Billable</p>
                                        <p>{"**"}</p>
                                    </li>
                                    <li>
                                        <p>Total Month Earnings</p>
                                        <p>{formatCurrency(earnings)}</p>
                                    </li>
                                    <li>
                                        <p>Annualized Earnings</p>
                                        <p>{formatCurrency(annualizedPay)}</p>
                                    </li>
                                    <li>
                                        <p>Avg Daily Earnings</p>
                                        <p>{formatCurrency(dailyRatePay)}</p>
                                    </li>
                                    <li>
                                        <p>Pt Visits</p>
                                        <p>{patientVisits}</p>
                                    </li>
                                    <li>
                                        <p>Pt Visits/ Day </p>
                                        <p>{patientVisitsPerDay}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>Contract Details</h5>
                                <ul className="data-list">
                                    <li>
                                        <p>Contract Type</p>
                                        <p>{contractType}</p>
                                    </li>
                                    <li>
                                        <p>Monthly Base Work Days </p>
                                        <p>{doctorPayVariables.monthlyBaseWorkDays}</p>
                                    </li>
                                    <li>
                                        <p>Day Rate</p>
                                        <p>{doctorPayVariables.dailyRatePay}</p>
                                    </li>
                                    <li>
                                        <p>Billable Care Threshold</p>
                                        <p>{"**"}</p>
                                    </li>
                                    <li>
                                        <p>Percentage of Billable Care </p>
                                        <p>{percentageOfBillable ? percentageOfBillable.toFixed(0) : 'Error'}</p>
                                    </li>
                                    <li>
                                        <p>Gross to Billable Adjustment Percentage</p>
                                        <p>{100 - prodAdjWo}</p>
                                    </li>
                                    <li>
                                        <p>Work Status</p>
                                        <p>{dentistWorkTimeType}</p>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="ui card reports-card">
                            <div className="content">
                                {
                                    payChecks && Object.entries(payChecks).map(([date, dateChecks], i) => <div>
                                        <div className="d-flex justify-content-between flex-wrap">
                                            <h5 className="mr10">{i + 1}{(1 + i) === 1 ? 'st' : 'nd'} Friday Gross Earnings
                                                Pre-Tax</h5>
                                            <strong className="secondaryColor text-right">{date}</strong>
                                        </div>
                                        <table className="table table-striped table-hover table-sm mt-0 mb-0">
                                            <thead>
                                                <tr>
                                                    <th>OFFICE</th>
                                                    <th className="text-right">EARNINGS</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dateChecks.officeChecks.map((office) => (
                                                    <tr key={i}>
                                                        <td>{office.practice}</td>
                                                        <td className="text-right">{formatCurrency(office.check)}</td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                    <td><strong>Total</strong></td>
                                                    <td className="text-right">
                                                        <strong>{formatCurrency(dateChecks.total)}</strong>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>)
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>Accessing Your Pay Stub</h5>
                                <ul className="data-list">
                                    <li>
                                        <p>Link to ADP</p>
                                        <p><a href={adpLink} target={'_blank'}><Icon name='external alternate'
                                            className="primaryColor" /></a></p>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="row">
                </div>
                {showFinancialNotesTable(financialNoteList, financialNotes)}
                {showTedCollectionsTable(details.payDetailsList)}
                <div className="table-responsive">
                    <h5>Pay Details</h5>
                    <table className="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th>
                                    <div>SERVICE DATE</div>
                                </th>
                                <th>
                                    <div>PRACTICE</div>
                                </th>
                                <th>
                                    <div>GROSS CARE</div>
                                </th>
                                <th>
                                    <div>ADJUSTMENT</div>
                                </th>
                                <th>
                                    <div>WRITE OFF</div>
                                </th>
                                <th>
                                    <div>BILLABLE CARE</div>
                                </th>
                                {Object.keys(hygData).length > 0 && <th>
                                    <div>HYN BCARE</div>
                                </th>}
                                <th>
                                    <div>FINANCIAL NOTES</div>
                                </th>
                                <th>
                                    <div>EARNINGS</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {payDetails}
                            {payDetails.length < 1 && (<tr key={`payDetailsRowTotal`}>
                                <td colSpan={8}><strong>No records found</strong></td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default GOx;